export default "__VITE_ASSET__ff82cafa__"